<template>
  <Layout v-if="aupair">
    <h2 class="text-xl mb-5">
      Are you sure you would like to cancel your interview with
      <strong>{{ aupair.firstName }}</strong> ?
    </h2>

    <ChiCard>
      <div
        v-if="!processing"
        class="w-full flex flex-col lg:flex-row p-5 justify-around items-center"
      >
        <button
          @click.prevent="cancelInterview(aupair.auPairPromoProfileId)"
          class="btn bg-green-600 text-white mb-10 lg:mb-0"
        >
          Yes, cancel interview
        </button>
        <button @click.prevent="giveUp()" class="btn">
          No, return to list
        </button>
      </div>
      <ComponentLoading v-else />
    </ChiCard>
  </Layout>
</template>

<script>
import { api } from "@/services.js";
import Layout from "@/Layout/Authenticated/Layout.vue";
import ChiCard from "@/components/UI/ChiCard.vue";

export default {
  name: "CancelInterviewConfirmation",
  props: ["aupair"],
  components: {
    Layout,
    ChiCard,
  },
  data() {
    return {
      processing: false,
    };
  },
  created() {
    if (!this.aupair) {
      this.$router.push({ name: "RequestInterview" });
    }
  },
  methods: {
    giveUp() {
      this.$router.push({ name: "RequestInterview" });
    },
    async cancelInterview(aupairPromoProfileId) {
      try {
        this.processing = true;
        await api.delete(
          `/promotional/AuPairPromoProfiles/${aupairPromoProfileId}/interviews`
        );

        await this.$store.dispatch("getUser");
        await this.$toasted.global.notificate({
          message: "Your interview was cancelled.",
          type: "success",
        });
        this.$router.push({ name: "RequestInterview" });
      } catch (error) {
        this.$toasted.global.notificate({
          message: error.response.data.message,
          type: "error",
        });
      }
    },
  },
};
</script>
